<template>
    <div class="seal-record">
        <p class="mt10">印章备案</p>
        <el-table :data="logs"
                  border>
            <el-table-column label="印章"
                             width="280">
                <template slot-scope="scope">
                    <div class="transform-center">
                        <img :src="`${BASE_APP_PATH}/seal/image?fileKey=${scope.row.pic_key}`"
                             alt="">
                        <span :title="scope.row.seal_name"
                              class="name-ellipsis">{{scope.row.seal_name}}</span>
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="证书信息">
                <template slot-scope="scope">
                    <el-button type="text"
                               class="black-text"
                               @click="doViewCert(scope.row.cert)">点击查看</el-button>
                </template>
            </el-table-column>
            <el-table-column label="颁发者信息"
                             prop="issuer"></el-table-column>
            <el-table-column label="备案时间"
                             prop="createTime"></el-table-column>
            <el-table-column label="操作">
                <template slot-scope="scope">
                    <el-button type="default"
                               size="small"
                               @click="doDelete(scope.row.id)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>

        <el-pagination class="seal-page"
                       background
                       @current-change="changePage"
                       :current-page.sync="filter.pageNo"
                       :page-size.sync="filter.pageSize"
                       layout="total, prev, pager, next"
                       :total="totalCount"></el-pagination>

        <cert-info :visible.sync="showCertDialog"
                   v-if="certKey"
                   :cert-key="certKey"></cert-info>
    </div>
</template>

<script>
import CertInfo from './childs/cert.vue';

export default {
    components: { CertInfo },
    data () {
        return {
            logs: [],
            filter: {
                pageNo: 1,
                pageSize: 10
            },
            totalCount: 0,
            certKey: '',
            showCertDialog: false
        };
    },
    props: {
        hideNavigate: Boolean
    },
    mounted () {
        this.getSealRecordList();
    },
    methods: {
        /**
         * 查看证书
         */
        doViewCert (key) {
            this.certKey = key;
            this.showCertDialog = true;
        },

        /**
         * 删除印章备案
         */
        async doDelete (id) {
            try {
                await this.$confirm('是否确认删除本条记录？', '删除印章备案', {
                    type: 'warning'
                });
                this.loading = this.$loading({
                    text: '加载中...'
                });
                let resp = await this.axios({
                    url: '/seal/record/delete',
                    method: 'GET',
                    params: { id }
                });
                if (resp.data.code === 0) {
                    this.$message.success('删除成功!');
                    this.getSealRecordList(true);
                } else {
                    this.$message.error(resp.data.message);
                }
            } catch (error) {
                console.log(error);
            } finally {
                this.loading && this.loading.close();
            }
        },

        changePage (page) {
            this.filter.pageNo = page || 1;
            this.getSealRecordList();
        },

        async getSealRecordList () {
            let resp;
            try {
                resp = await this.axios({
                    url: '/seal/record/query/page',
                    method: 'GET',
                    params: this.filter
                });
                resp = resp.data;
                if (resp.code === 0) {
                    this.logs = resp.result;
                    this.totalCount = resp.page.totalCount;
                }
            } catch (error) {
                console.log(error);
            }
        },
    }
};
</script>

<style lang="less" scoped>
.seal-record {
    margin: 15px 0;
    border-top: 1px solid @border-color-base;
}
.mt10 {
    margin-bottom: 10px;
}
.transform-center {
    img {
        width: 60px;
        margin-right: 20px;
    }
    span {
        display: block;
        flex: 1;
    }
}
.seal-page {
    text-align: right;
    margin: 20px auto 0;
}
</style>
